// extracted by mini-css-extract-plugin
module.exports = {"desktopModal":"AddAffiliateModal_desktopModal__dQSL2"};